import { action, computed } from 'easy-peasy';
import { createContextStoreWithRuntimeModel } from '../helpers/context-store.helpers';
import {
    ServiceAgreementCalculatorState,
    ServiceAgreementCalculatorStore,
    ServiceAgreementCalculatorStoreAction,
} from './service-agreement-calculator.types';

const defaultStates = (): ServiceAgreementCalculatorState => ({
    customerInfo: {
        email: '',
        name: '',
        isPolicyAccepted: false,
        consent: false,
        consentText:
            'Ja tak, jeg vil gerne holdes opdateret af Ejner Hessel A/S via telefon, e-mail og SMS om biler, tilbehør og ydelser til biler, reparation/service af biler, events og konkurrencer. Ejner Hessel må kontakte mig for udvidelse af samtykket. Du kan til enhver tid tilbagekalde dit samtykke på digital@hessel.dk',
    },
    serviceAgreements: undefined,
    vehicleInformation: {
        licensePlate: '',
    },
    modalOpen: false,
});

const actions = (): ServiceAgreementCalculatorStoreAction => ({
    setVehicleInformation: action((state: ServiceAgreementCalculatorState, payload) => {
        state.vehicleInformation = payload;
    }),
    setServiceAgreements: action((state: ServiceAgreementCalculatorState, payload) => {
        state.serviceAgreements = payload;
    }),
    setLicensePlate: action((state: ServiceAgreementCalculatorState, payload) => {
        state.vehicleInformation.licensePlate = payload;
    }),
    setCustomerInfo: action((state: ServiceAgreementCalculatorState, payload) => {
        state.customerInfo = payload;
    }),
    setSelectedCompleteCare: action((state: ServiceAgreementCalculatorState, payload) => {
        state.selectedCompleteCare = payload;
    }),
    setSelectedServiceCare: action((state: ServiceAgreementCalculatorState, payload) => {
        state.selectedServiceCare = payload;
    }),
    setSelectedWarrantyExtension: action((state: ServiceAgreementCalculatorState, payload) => {
        state.selectedWarrantyExtension = payload;
    }),
    clearAllAgreements: action((state: ServiceAgreementCalculatorState) => {
        state.selectedCompleteCare = undefined;
        state.selectedServiceCare = undefined;
        state.selectedWarrantyExtension = undefined;
    }),
    setModalOpen: action((state: ServiceAgreementCalculatorState, payload: boolean) => {
        state.modalOpen = payload;
    }),
    noAgreements: computed((state: ServiceAgreementCalculatorState) => {
        return [state.serviceAgreements?.serviceCare, state.serviceAgreements?.completeCare, state.serviceAgreements?.warrantyExtensions].every(
            (x) => x?.length === 0
        );
    }),
});

export const ServiceAgreementCalculatorModalStore = createContextStoreWithRuntimeModel<ServiceAgreementCalculatorStore>(
    () => ({
        ...defaultStates(),
        ...actions(),
    }),
    { name: 'serviceAgreementCalculator' }
);
